<template>
  <v-container>
    <!-- BOC:[breadcrumbs] -->
    <ABreadcrumb :items="breadcrumbs"></ABreadcrumb>
    <!-- EOC -->

    <!-- BOC:[error] -->
    <AError
      v-if="api.isError"
      :api="api"
      :callbackReset="() => (api.isError = false)"
    ></AError>
    <!-- EOC -->

    <v-card class="mx-auto pa-3" max-width="800" outlined min-height="200">
      <v-card-title>New Mission</v-card-title>

      <ALoader :isLoading="api.isLoading || studentApi.isLoading"></ALoader>

      <div
        class="d-flex align-center justify-space-around"
        v-if="!studentApi.isLoading"
      >
        <div v-if="mochiId" class="form-content text-center">
          <v-form ref="formName" v-model="valid" lazy-validation>
            <div class="text-center pt-3">
              <Syllabus
                ref="syllabus"
                :callbackSelect="selectSyllabus"
                :callbackError="showError"
              />
            </div>
            <div v-if="syllabus && syllabus.key" class="text-center pt-4">
              <Chapter
                ref="chapter"
                :syllabus="syllabus"
                :callbackSelect="selectChapter"
                :callbackError="showError"
                @input="form.chapterKey = $event"
              />
            </div>
            <div v-if="chapter && chapter.key" class="text-center pt-4">
              <Question
                ref="question"
                :chapter="chapter"
                :callbackSelect="selectQuestion"
                :callbackError="showError"
                @input="form.questionKey = $event"
              />
            </div>

            <div class="text-center pt-3">
              <v-btn
                :loading="api.isLoading"
                width="75%"
                color="primary"
                dark
                rounded
                @click="submit()"
              >
                Submit
              </v-btn>
            </div>
            <div class="text-center pt-2">
              <v-btn
                width="75%"
                text
                color="primary"
                rounded
                :to="{
                  name: 'PageEducatorClassroomStudentRead',
                  params: {
                    id: $route.params.parentId,
                    parentId: $route.params.classroomId,
                  },
                }"
              >
                Cancel
              </v-btn>
            </div>
          </v-form>
        </div>

        <div v-else>
          <p>MochiId not found</p>
          <v-btn
            width="75%"
            text
            color="primary"
            rounded
            :to="{
              name: 'PageEducatorClassroomStudentRead',
              params: {
                id: $route.params.parentId,
                parentId: $route.params.classroomId,
              },
            }"
          >
            Cancel
          </v-btn>
        </div>
      </div>
    </v-card>
  </v-container>
</template>

<script>
import Syllabus from "@/components/Bread/Mission/Syllabus";
import Chapter from "@/components/Bread/Mission/Chapter";
import Question from "@/components/Bread/Mission/Question";

export default {
  components: {
    Syllabus,
    Chapter,
    Question,
  },
  data: () => ({
    valid: false,
    // BOC:[breadcrumbs]
    breadcrumbs: [],
    // EOC
    syllabus: {},
    chapter: {},
    question: null,
    student: {},
    mochiId: null,
    form: {},
    // APIs
    api: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    studentApi: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
  }),
  created() {
    // Setup API callbacks like user mission add
    this.api.callbackReset = () => {
      this.api.isLoading = true;
      this.api.isError = false;
    };
    this.api.callbackError = (e) => {
      this.api.isLoading = false;
      this.api.isError = true;
      this.api.error = e;
    };
    this.api.callbackSuccess = () => {
      this.api.isLoading = false;
      this.$toast &&
        this.$toast.success &&
        this.$toast.success("Mission created successfully!");
      this.$router.push({
        name: "PageEducatorInstitutionClassroomStudentRead",
        params: {
          id: this.$route.params.id,
          parentId: this.$route.params.parentId,
          grandparentId: this.$route.params.grandparentId,
        },
      });
    };

    this.loadStudent();
  },
  methods: {
    loadStudent() {
      this.studentApi.method = "GET";
      this.studentApi.url =
        this.$api.servers.sso +
        "/api/v1/" +
        this.$_getLocale() +
        "/educator/classroom/" +
        this.$route.params.parentId +
        "/student/" +
        this.$route.params.id;

      this.studentApi.callbackReset = () => {
        this.studentApi.isLoading = true;
        this.studentApi.isError = false;
      };

      this.studentApi.callbackError = (e) => {
        this.studentApi.isLoading = false;
        this.studentApi.isError = true;
        this.studentApi.error = e;
      };

      this.studentApi.callbackSuccess = (resp) => {
        this.studentApi.isLoading = false;
        this.student = resp || {};
        this.mochiId = resp && resp.mochiId ? resp.mochiId : null;

        // Build mission add URL like user mission add
        if (this.mochiId) {
          this.api.url =
            this.$api.servers.game +
            "/api/v1/" +
            this.$_getLocale() +
            "/backend/player/" +
            this.mochiId +
            "/mission/add";
        }

        this.updateBreadcrumb(resp);
      };

      this.$api.fetch(this.studentApi);
    },

    updateBreadcrumb(resp) {
      this.breadcrumbs = [];
      this.breadcrumbs.push({
        text: "Dashboard",
        to: { name: "PageEducatorDashboard" },
        exact: true,
      });
      this.breadcrumbs.push({
        text: "My Institution",
        to: {
          name: "PageEducatorInstitutionDashboard",
          params: { id: this.$route.params.supergrandparentId },
        },
        exact: true,
      });
      this.breadcrumbs.push({
        text: "Classrooms",
        to: {
          name: "PageEducatorInstitutionClassroom",
          params: { id: this.$route.params.supergrandparentId },
        },
        exact: true,
      });
      if (resp && resp.Classroom && resp.Classroom.name) {
        this.breadcrumbs.push({
          text: resp.Classroom.name,
          to: {
            name: "PageEducatorClassroomDashboard",
            params: {
              id: this.$route.params.grandparentId,
              parentId: this.$route.params.supergrandparentId,
            },
          },
          exact: true,
        });
      }
      this.breadcrumbs.push({
        text: "Students",
        to: {
          name: "PageEducatorClassroomStudent",
          params: {
            id: this.$route.params.grandparentId,
            parentId: this.$route.params.supergrandparentId,
          },
        },
        exact: true,
      });
      if (resp && resp.name) {
        this.breadcrumbs.push({
          text: resp.name,
          to: {
            name: "PageEducatorClassroomStudentRead",
            params: {
             id: this.$route.params.parentId,
              parentId: this.$route.params.grandparentId,
              grandparentId: this.$route.params.supergrandparentId,
            },
          },
          exact: true,
        });
      }
      this.breadcrumbs.push({
        text: "Add Mission",
        to: { name: "PageEducatorInstitutionClassroomStudentMissionAdd" },
        exact: false,
      });
    },

    selectSyllabus(item) {
      this.syllabus = item;
      setTimeout(() => {
        this.$refs["chapter"] && this.$refs["chapter"].fetch();
      }, 100);
    },
    selectChapter(item) {
      this.chapter = item;
      this.form.chapterKey = item.key;
      setTimeout(() => {
        this.$refs["question"] && this.$refs["question"].fetch();
      }, 100);
    },
    selectQuestion(item) {
      this.question = item;
      this.form.questionKey = item.key;
    },

    showError(e) {
      this.$toast &&
        this.$toast.error &&
        this.$toast.error(e && e.message ? e.message : "Error");
    },

    submit() {
      if (!this.mochiId) {
        this.$toast &&
          this.$toast.error &&
          this.$toast.error("Student does not have a Mochi ID linked");
        return;
      }
      if (!this.form.questionKey) {
        this.$toast &&
          this.$toast.error &&
          this.$toast.error("Please select a question");
        return;
      }
      this.api.params = this.$_.clone(this.form);
      this.$api.fetch(this.api);
    },
  },
};
</script>

<style scoped>
.form-content {
  width: 600px !important;
}
</style>